export const FlipbookLibs = {
  defined: true
};

export default FlipbookLibs;
